import freeButtonImg from '../assets/free-button.png'
import buyButtonImg from '../assets/buy-button.png'

export interface TrialCTASectionProps {
  isLoading: boolean
  onClick: () => void
  showBadges?: boolean
  asInline?: boolean
  isReturning?: boolean
}

export default function TrialCTASection({
  isLoading,
  onClick,
  showBadges = true,
  asInline = false,
  isReturning = false,
}: TrialCTASectionProps) {
  const badges = showBadges && !isReturning && (
    <div className="mb-3 flex items-center gap-1 md:gap-2">
      <span className="text-[#3E2F00] text-xs md:text-sm font-medium">今なら3日間無料</span>
      <span className="inline-block rounded-[4px] bg-[#F7E380] text-[#3E2F00] px-1 py-0.5 text-xs md:text-sm font-medium shadow-[0_1px_0_rgba(0,0,0,0.06)]">
        いつでもキャンセル可能
      </span>
    </div>
  )

  const button = (
    <button
      type="button"
      onClick={onClick}
      disabled={isLoading}
      className={`group w-full md:w-[680px] p-0 bg-transparent border-0 shadow-none rounded-none ${
        isLoading ? 'cursor-not-allowed opacity-70' : ''
      }`}
    >
      <img
        src={isReturning ? buyButtonImg : freeButtonImg}
        alt={isReturning ? '' : '無料で試してみる'}
        className="w-full h-auto"
      />
    </button>
  )

  if (asInline) {
    return (
      <div className="flex flex-col items-center">
        {badges}
        {button}
      </div>
    )
  }

  return (
    <section className="mx-auto max-w-6xl pt-3 px-6 pb-6 bg-[#F8F8F8]">
      <div className="flex flex-col items-center">
        {badges}
        {button}
      </div>
    </section>
  )
}
